import { render, staticRenderFns } from "./ActionsComponent.vue?vue&type=template&id=26130541&scoped=true"
import script from "./ActionsComponent.vue?vue&type=script&lang=js"
export * from "./ActionsComponent.vue?vue&type=script&lang=js"
import style0 from "./ActionsComponent.vue?vue&type=style&index=0&id=26130541&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26130541",
  null
  
)

export default component.exports